import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap"
import React from "react"
import { SearchSelect } from "./search_select"
import { useGetCrsCoursesQuery } from "../api/courses"
import { useState } from "react"

export const ImportCourseModal = ({show, setShow}) => {
  const [searchQuery, setSearchQuery] = useState()
  const [selectedCourse, setSelectedCourse] = useState()

  const {data: options, isLoading} = useGetCrsCoursesQuery({q: searchQuery}, {skip: !show || !searchQuery})

  const handleSearchChange = (value) => {
    setSearchQuery(value)
  }

  const handleSelectChange = (event) => {
    setSelectedCourse(event.target.value)
  }

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="center-modal">
          <div className="courses-modal-title-container">
            <div className="courses-modal-title">
              IMPORT FROM USGA COURSE RATING DIRECTORY
            </div>
          </div>
          <ModalBody className="courses-modal-body-container">
            <div className="courses-modal-dropdown-label add-margin-top-10">
              Select course to import
            </div>
            <SearchSelect 
              placeholder='Select Course'
              handleSearchChange={handleSearchChange}
              handleSelectChange={handleSelectChange}
              options={options}
              isLoading={isLoading}/>
            <div className="btsp_notices add-margin-top-20">
              Type a few characters into the search box and choose the golf course you wish to import from the USGA Course Rating™ Directory. This will allow Hole-by-Hole Score Posting and scores will be considered in the Playing Conditions Calculation (PCC).
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="courses-modal-buttons-container">
              <button className="cancel_action small grey button btsp_small_white_button">Cancel</button>
              <button className="next_action small orange button btsp_small_orange_button">Next</button>
            </div>
          </ModalFooter>
      </Modal>
    </>
  )
}